import React, { useMemo } from 'react'
import { Table } from 'shared/ui/Table/Table'
import { Box, Button } from '@mui/material'
import { Column } from 'shared/ui/Table/types'

export function CountTable({
  data,
  header1,
  header2 = 'Count',
  onSelect,
  extraColumns = [],
  filteredKeys,
}: {
  header1: string
  header2?: string
  data: Record<string, unknown[]>
  onSelect?: (key: string) => void
  extraColumns?: Column<string>[]
  filteredKeys?: string[]
}) {
  const displayKeys = useMemo(() => {
    return filteredKeys ?? Object.keys(data)
  }, [data, filteredKeys])

  const columns = [...getCountColumns(header1, header2, data), ...extraColumns]

  if (onSelect) {
    columns.push({
      title: '',
      rowContent(key) {
        return <Button onClick={() => onSelect(key)}>Select</Button>
      },
    })
  }

  return (
    <Box>
      <Table<string> canExport={true} columns={columns} items={displayKeys} />
    </Box>
  )
}

function getCountColumns(
  title1: string,
  title2: string,
  data: Record<string, unknown[]>,
): Column<string>[] {
  return [
    {
      title: title1,
      rowContent(title) {
        return title
      },
    },
    {
      title: title2,
      rowContent(key) {
        return data[key].length
      },
    },
  ]
}
